document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.mobile-menu-toggle');
  var menu = document.querySelector('.mobile-nav');
  if (toggle && menu) toggle.addEventListener('click', function () {
    var open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.textContent = open ? '✕' : '☰';
  });

  document.querySelectorAll('[data-quick-add]').forEach(function(button){
    button.addEventListener('click', async function(){
      var original = button.textContent;
      button.disabled = true; button.textContent = 'ADDING…';
      try {
        var response = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(button.dataset.variant),quantity:1}]})
        });
        if(!response.ok) throw new Error('Cart error');
        button.textContent='ADDED ✓';
        var count=document.querySelector('.cart-count'); if(count) count.textContent=Number(count.textContent||0)+1;
        setTimeout(function(){button.textContent=original;button.disabled=false;},1400);
      } catch(e) { button.textContent='VIEW PRODUCT'; button.disabled=false; }
    });
  });
});
